import { useQuery } from '@tanstack/react-query';

import { createEntityMutations } from '../../../shared/api/createEntityMutations.js';
import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import {
  createMeeting,
  deleteMeeting,
  getMeetingById,
  getMeetingDetailQueryKey,
  getMeetingsQueryKey,
  listMeetings,
  updateMeeting,
  type CreateMeetingInput,
  type ListMeetingsFilters,
  type MeetingItem,
  type UpdateMeetingInput,
} from '../api/meetings.client.js';

export function useMeetings(filters: ListMeetingsFilters = {}) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: getMeetingsQueryKey(workspaceId, filters),
    queryFn: () => listMeetings(filters),
    enabled: scope !== null,
  });
}

/** Одна встреча — для её карточки. */
export function useMeeting(meetingId: string) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: getMeetingDetailQueryKey(workspaceId, meetingId),
    queryFn: () => getMeetingById(meetingId),
    enabled: scope !== null,
  });
}

const meetingMutations = createEntityMutations<MeetingItem, CreateMeetingInput, UpdateMeetingInput>(
  {
    key: 'meetings',
    create: createMeeting,
    update: updateMeeting,
    remove: deleteMeeting,
  },
);

export const useCreateMeetingMutation = meetingMutations.useCreate;
export const useUpdateMeetingMutation = meetingMutations.useUpdate;
export const useDeleteMeetingMutation = meetingMutations.useDelete;
